import React, { useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../../api/api";
import { useUser } from "../../../../providers/UserProvider";
import {
  IBatchIdsWriteOff,
  IWriteOffProductsOrder,
  OrderStatus,
} from "../../../../types/order.type";
import { IPhoneOrder } from "../../../../types/phoneOrder.type";
import { IProduct } from "../../../../types/product.type";
import { ISelectsInput } from "../../../../types/selects.type";
import { formatDate } from "../../../../utils/formatDate";
import ResourceCountButton from "../../../buttons/ResourceCountButton/ResourceCountButton";
import SelectChangeProdListInput from "../../../inputs/SelectChangeProdListInput/SelectChangedProdListInput";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  products: IProduct[];
  order: IPhoneOrder;
}

const AddPhoneOrderBoxingForm: React.FC<Props> = (props) => {
  const user = useUser();
  const [search, setSearch] = useState<string>("");
  const [selectedProducts, setSelectedProducts] = useState<ISelectsInput[]>([]);

  const getWarehouse = () => {
    const result: ISelectsInput[] = [];
    for (const product of props.products) {
      for (const batch of product.batches) {
        if (batch.batchQuantity > 0) {
          result.push({
            id: batch.id,
            name: product.name,
            subName: product.capacity,
            secondSubName: `${batch.batchName}/${formatDate(batch.batchDate)}`,
            count: batch.batchQuantity,
            selectCount: 0,
            resourceId: product.id,
          });
        }
      }
    }
    return result;
  };

  const onPressWithdraw = async () => {
    try {
      const process = await authApiService.createPhoneOrderProccessing({
        orderId: props.order.id,
      });

      if (process) {
        const batchIds: IBatchIdsWriteOff[] = [];
        for (const item of selectedProducts) {
          if (item.selectCount && item.selectCount > 0) {
            batchIds.push({ batchId: item.id, quantity: item.selectCount });
          }
        }

        if (user.user?.id) {
          const body: IWriteOffProductsOrder = {
            processingId: process.id,
            batchIds,
            userId: user.user.id,
          };

          const response = await authApiService.writeOffPhoneOrder(body);

          if (response) {
            await authApiService.updatePhoneOrderStatus(props.order.id, {
              status: OrderStatus.PACKED,
            });
            props.onApply();
            props.onClose();
          }
        }
      }
    } catch (err: any) {
      console.error(err);
      toast.error(err.message);
    }
  };

  console.log(props.order.orderProducts);
  console.log(selectedProducts);

  return (
    <div className={styles.container}>
      <div className={`${styles.headerContainer}`}></div>
      <div className={styles.formContainer}>
        <form className={styles.form}>
          <SelectChangeProdListInput
            items={getWarehouse()}
            title="Warehouse"
            values={selectedProducts}
            onClickActive={(value) => {
              setSelectedProducts((prevState) =>
                prevState.filter((item) => item.id !== value.id)
              );
            }}
            onClickInactive={(value) =>
              setSelectedProducts((prevState) => [...prevState, value])
            }
            onChangeCount={(id, value) => {
              const findIndex = selectedProducts.findIndex(
                (item) => item.id === id
              );
              if (findIndex !== -1) {
                const newState = [...selectedProducts];
                newState[findIndex].selectCount = value;
                setSelectedProducts(newState);
              }
            }}
            search={search}
            setSearch={(value) => setSearch(value)}
            isMultiSelect={true}
          />
        </form>
        <form className={styles.formSelect}>
          {props.order.orderProducts.map((item) => (
            <ResourceCountButton
              name={item.product.name}
              capacity={item.product.capacity}
              needCount={item.quantity}
              count={(() => {
                const res = selectedProducts.filter(
                  (i) => i.resourceId === item.product.id
                );

                return res.reduce((acc, i) => {
                  if (i.selectCount) {
                    return (acc += i.selectCount);
                  }
                  return acc;
                }, 0);
              })()}
              isActive={true}
              onClick={(value) => setSearch(value)}
            />
          ))}
          {selectedProducts
            .filter(
              (prod) =>
                !props.order.orderProducts.some(
                  (i) => i.product.id === prod.resourceId
                )
            )
            .map((item) => (
              <ResourceCountButton
                name={item.name}
                needCount={0}
                count={item.selectCount ? item.selectCount : 0}
                isActive={true}
                onClick={(value) => setSearch(value)}
              />
            ))}
        </form>
      </div>

      <ModalBottomButtons
        onPressApply={onPressWithdraw}
        applyTitle="Withdraw"
        onPressBack={props.onClose}
        backTitle="Back"
        isApplyDisabled={(() => {
          if (selectedProducts.length === 0) {
            return true;
          }
          const res = props.order.orderProducts.map((item) => ({
            id: item.product.id,
            quantity: item.quantity,
          }));
          return !selectedProducts.every(
            (item) =>
              res.find((i) => i.id === item.resourceId)?.quantity ===
              item.selectCount
          );
        })()}
      />
    </div>
  );
};

export default AddPhoneOrderBoxingForm;
